
export const menuDefault = [
  {
    key: "home",
    title: "HOME",
    url: "/",
  },
];

export const vipMenus = [
  {
    key: "services",
    title: "SERVICES",
    submenu: [
      {
        key: "vipLoungeMembershipCard",
        title: "VIP LOUNGE MEMBERSHIP CARD",
        target: "_blank",
      },
      {
        key: "arrival",
        title: "ARRIVAL",
        target: "_blank",
      },
      {
        key: "departure",
        title: "DEPARTURE",
        target: "_blank",
      },
      {
        key: "bundle",
        title: "BUNDLE",
        target: "_blank",
      },
      // {
      //   key: "otherAirportService",
      //   title: "OTHER AIRPORT SERVICES",
      //   submenu: [
      //     {
      //       key: "destinationWedding",
      //       title: "DESTINATION WEDDING",
      //       target: "_blank",
      //     },
      //     {
      //       key: "families",
      //       title: "FAMILIES",
      //       target: "_blank",
      //     },
      //     {
      //       key: "group",
      //       title: "GROUP",
      //       target: "_blank",
      //     },
      //     {
      //       key: "businessTraveller",
      //       title: "BUSINESS TRAVELERS",
      //       target: "_blank",
      //     },
      //     {
      //       key: "seniorCitizens",
      //       title: "SENIOR CITIZENS",
      //       target: "_blank",
      //     },
      //     {
      //       key: "unaccompainedMinor",
      //       title: "UNACCOMPAINED MINOR",
      //       target: "_blank",
      //     },
      //   ],
      // },
      {
        key: "telecomService",
        title: "TELECOM SERVICES",
      },
      {
        key: "retail",
        title: "RETAIL",
        target: "_blank",
      },
      {
        key: "accessAndMembership",
        title: "ACCESS & MEMBERSHIP",
        target: "_blank",
      },
      {
        key: "spa",
        title: "SPA",
        target: "_blank",
      },
    ],
  },
  {
    key: "communication",
    title: "COMMUNICATION",
    submenu: [
      // {
      //   key: "vipNews",
      //   title: "VIP NEWS",
      //   submenu: [
      //     {
      //       key: "media",
      //       title: "MEDIA",
      //       target: "_blank",
      //     },
      //     {
      //       key: "ourRewards",
      //       title: "OUR REWARDS",
      //       target: "_blank",
      //     },
      //     {
      //       key: "vipSocialResponsibilities",
      //       title: "VIP SOCIAL RESPONSIBILITIES",
      //       target: "_blank",
      //     },
      //     {
      //       key: "thingsToDoInJamaica",
      //       title: "THINGS TO DO IN JAMAICA",
      //       target: "_blank",
      //     },
      //   ],
      // },
      {
        key: "gallery",
        title: "GALLERY",
        target: "_blank",
      },
      {
        key: "videos",
        title: "VIDEOS",
        target: "_blank",
      },
      {
        key: "brochuresAndForms",
        title: "BROCHURES & FORMS",
        target: "_blank",
      },
      {
        key: "testimonials",
        title: "TESTIMONIALS",
        target: "_blank",
      },
      {
        key: "thanksForMakingThingsBetter",
        title: "THANKS FOR MAKING THINGS BETTER",
        target: "_blank",
      },
      {
        key: "faq",
        title: "FAQ",
        target: "_blank",
      },
      {
        key: "safetyProtocols",
        title: "SAFETY PROTOCOLS",
        target: "_blank",
      },
    ],
  },
  {
    key: "vipAttractions",
    title: "VIP ATTRACTIONS",
    submenu: [
      {
        key: "whoWeAre",
        title: "WHO WE ARE",
        target: "_blank",
      },
      {
        key: "directorAndManagement",
        title: "THE TEAM DIRECTOR",
        target: "_blank",
      },
      {
        key: "clubMobayVacancies",
        title: "CLUB MOBAY VACANCIES",
        target: "_blank",
      },
      {
        key: "clubKingstonVacancies",
        title: "CLUB KINGSTON VACANCIES",
        target: "_blank",
      },
      {
        key: "corporateOfficeVacancies",
        title: "CORPORATE OFFICE VACANCIES",
        target: "_blank",
      },
      {
        key: "airports",
        title: "AIRPORT",
        target: "_blank",
      },
      {
        key: "contact",
        title: "CONTACT",
        target: "_blank",
      },
    ],
  },
];

export const menuVIPMembershipCard = [
  {
    key: "vipMembershipCard",
    title: "VIP AIRPORT LOUNGE MEMBERSHIP",
    submenu: [
      {
        key: "purchaseMembership",
        title: "PURCHASE MEMBERSHIP",
      },
      {
        key: "topupMembership",
        title: "TOPUP MEMBERSHIP",
      },
      {
        key: "changeMemberPin",
        title: "CHANGE MEMBERSHIP PIN",
      },
      {
        key: "resetMemberPin",
        title: "RESET MEMBERSHIP PIN",
      },
      {
        key: "memberProfile",
        title: "MEMBERSHIP PROFILE",
      },
      {
        key: "unlockMemberCard",
        title: "UNLOCK MEMBERSHIP",
      },
    ],
  },
];

export const menuFeedback = [
  {
    key: "feedback",
    title: "FEEDBACK",
  },
];

export const menuGetUpdateFlightDetailsLink = [
  {
    key: "getUpdateFlightDetailsLink",
    title: "UPDATE FLIGHT DETAILS",
  },
];
